import Backbone from 'backbone';
import { log } from 'handlebars';
import toastr from 'toastr';

var GeneralView = {};

GeneralView.View = Backbone.View.extend({
    initialize: function() {
    },

	translate: function(e){
		if( lang !='es'){
			this.$el.find('.item').each(function(index, element){
				$(this).text(arrlang[lang][$(this).attr("key")]);
			});
		}
	},
	
	toastrButtons: function(txt, type){
        switch(type){
            case 'sucess':
                toastr.success(txt,"");
            break;
            case 'info':
                toastr.info(txt,"");
            break;
            case 'warning':
                toastr.warning(txt,"");
            break;
            case 'error':
                toastr.error(txt,"");
            break;
        }
	},
	
	settraz: function(trazreport,kind){
		var options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit' };
        var reporttraz = [];
        for (var i = 0; i < trazreport.comments.length; i++) {
            var user = "Auditor";
            if (trazreport.comments[i].attributes.createdby != undefined) {
                user = trazreport.comments[i].attributes.createdby.attributes.username;
            }
            var coment = {title:"Comentario", textreportid:"&#10142 Ir al reporte:", reportid: trazreport.comments[i].attributes.report.id, user: user, date: trazreport.comments[i].attributes.createdAt, content: "Comentario realizado", description: trazreport.comments[i].attributes.comment};
            reporttraz.push(coment)
        }
        for (var i = 0; i < trazreport.adminnotes.length; i++) {
            if (trazreport.adminnotes[i].attributes.createdby != undefined) {
            var adminnote = {title:"Nota de Auditor", textreportid:"&#10142 Ir al reporte:", reportid: trazreport.adminnotes[i].attributes.report.id, user: trazreport.adminnotes[i].attributes.createdby.attributes.username, date: trazreport.adminnotes[i].attributes.createdAt, content: "Nota de Bitácora Realizada", description: trazreport.adminnotes[i].attributes.note};
            reporttraz.push(adminnote);
            }
        }
        if (kind == 'report') {
            var report = {title: "Fecha de Creación" , textreportid:"&#10142 Ir al reporte:", reportid: trazreport.report[0].id, user: "Creado desde la app",date: trazreport.report[0].attributes.createdAt, content: "El reporte fue creado.", description: '...'};
            for (var i = 0; i < trazreport.auditreport.length; i++) {                
                var auditreport = {}; 
                if (trazreport.auditreport[i].attributes.action == "assignreport") {
                    var usern = 'Asignado automático';
                    if (trazreport.auditreport[i].attributes.user != undefined ) {
                        var usern = trazreport.auditreport[i].attributes.user.attributes.username;
                    }
                    var assigneduser = trazreport.auditreport[i].attributes.newvalue;
                    if(trazreport.auditreport[i].attributes.newvalueuser != undefined){
                        assigneduser = trazreport.auditreport[i].attributes.newvalueuser.attributes.username;
                    }
					var description = '...';
                    auditreport = {title: 'Reporte Asignado', user: usern, textreportid:"&#10142 Ir al reporte:", reportid: trazreport.auditreport[i].attributes.report.id, date: trazreport.auditreport[i].attributes.createdAt, content: "Reporte Asignado a: " + assigneduser, description: description};
                }
                if (trazreport.auditreport[i].attributes.action == "assignpriority") {
                    var usern = 'Usuario sin definir';
                    if (trazreport.auditreport[i].attributes.user != undefined) {
                        var usern = trazreport.auditreport[i].attributes.user.attributes.username;
                    }
					var description = '...';
                    if(trazreport.auditreport[i].attributes.newvalue == 0){
                        auditreport = {title: 'Prioridad Asignada', textreportid:"&#10142 Ir al reporte:",reportid: trazreport.auditreport[i].attributes.report.id, user: usern , date: trazreport.auditreport[i].attributes.createdAt,content: "Prioridad Sin Asignar", description: description};
                     }
                    if (trazreport.auditreport[i].attributes.newvalue == 1) {
                        auditreport = {title: 'Prioridad Asignada', textreportid:"&#10142 Ir al reporte:", reportid: trazreport.auditreport[i].attributes.report.id, user: usern , date: trazreport.auditreport[i].attributes.createdAt,content: "Prioridad Baja", description: description};    
                    }
                    if (trazreport.auditreport[i].attributes.newvalue == 2) {
                        auditreport = {title: 'Prioridad Asignada', textreportid:"&#10142 Ir al reporte:",reportid: trazreport.auditreport[i].attributes.report.id, user: usern , date: trazreport.auditreport[i].attributes.createdAt,content: "Prioridad Media", description: description};    
                    }
                    if (trazreport.auditreport[i].attributes.newvalue == 3) {
                        auditreport = {title: 'Prioridad Asignada', textreportid:"&#10142 Ir al reporte:",reportid: trazreport.auditreport[i].attributes.report.id, user: usern , date: trazreport.auditreport[i].attributes.createdAt,content: "Prioridad Alta", description: description};    
                    }
                } 
                if (trazreport.auditreport[i].attributes.action == "openreport") {
                    var usern = 'Reporte abierto automáticamente';
                    if (trazreport.auditreport[i].attributes.user != undefined) {
                        var usern = trazreport.auditreport[i].attributes.user.attributes.username;
                    }
					var description = '';
					if(trazreport.auditreport[i].attributes.reasonOfChangeStatus){
						description = trazreport.auditreport[i].attributes.reasonOfChangeStatus.attributes.reason;
					}
                    auditreport = {title: 'Estado del Reporte', textreportid:"&#10142 Ir al reporte:", reportid: trazreport.auditreport[i].attributes.report.id, user: usern , date: trazreport.auditreport[i].attributes.createdAt, content: "El estado de reporte cambio a: Abierto", description: description};
                }
                if (trazreport.auditreport[i].attributes.action == "closereport") {
                    var usern = 'Usuario sin definir';
                    if (trazreport.auditreport[i].attributes.user != undefined) {
                        var usern = trazreport.auditreport[i].attributes.user.attributes.username;
                    }
					var description = '';
					if(trazreport.auditreport[i].attributes.reasonOfChangeStatus){
						description = trazreport.auditreport[i].attributes.reasonOfChangeStatus.attributes.reason;
					}
                    auditreport = {title: 'Estado del Reporte', textreportid:"&#10142 Ir al reporte:", reportid: trazreport.auditreport[i].attributes.report.id, user: usern , date: trazreport.auditreport[i].attributes.createdAt, content: "El estado de reporte cambio a: Cerrado", description: description};
                }
                if (trazreport.auditreport[i].attributes.action == "discardreport") {
                    var usern = 'Usuario sin definir';
                    if (trazreport.auditreport[i].attributes.user != undefined) {
                        var usern = trazreport.auditreport[i].attributes.user.attributes.username;
                    }
					var description = '';
					if(trazreport.auditreport[i].attributes.reasonOfChangeStatus){
						description = trazreport.auditreport[i].attributes.reasonOfChangeStatus.attributes.reason;
					}
                    auditreport = {title: 'Estado del Reporte',textreportid:"&#10142 Ir al reporte:", reportid: trazreport.auditreport[i].attributes.report.id, user: usern , date: trazreport.auditreport[i].attributes.createdAt, content: "El estado de reporte cambio a: Descartado", description: description};
                }
                if (trazreport.auditreport[i].attributes.action == "changesubcat") {
                    var usern = 'Usuario sin definir';
                    if (trazreport.auditreport[i].attributes.user != undefined) {
                        var usern = trazreport.auditreport[i].attributes.user.attributes.username;
                    }
					var description = '';
					if(trazreport.auditreport[i].attributes.reasonOfChangeStatus){
						description = trazreport.auditreport[i].attributes.reasonOfChangeStatus.attributes.reason;
					}
                    auditreport = {title: 'Cambio de Categoría', textreportid:"&#10142 Ir al reporte:", reportid: trazreport.auditreport[i].attributes.report.id, user: usern , date: trazreport.auditreport[i].attributes.createdAt, content: "La categoría del reporte cambio a: "+trazreport.auditreport[i].attributes.newvalue , description: description};
                }
                reporttraz.push(auditreport);
            }
             reporttraz.push(report);
        } 
        if (kind == 'user') { 
            var user = {title: "Usuario creado",user: "Creado por usuario Administrador", date: trazreport.user[0].attributes.createdAt, content: "El usuario fue creado."};
            for (var i = 0; i < trazreport.auditnews.length; i++) {
                var auditnew = {};
                if (trazreport.auditnews[i].attributes.action == "new") {
                    if (trazreport.auditnews[i].attributes.New != undefined) { 
                        auditnew = {title: "Noticia Creada",user: trazreport.auditnews[i].attributes.user.attributes.username , date: trazreport.auditnews[i].attributes.createdAt, content:trazreport.auditnews[i].attributes.New.attributes.body };
                    }else{
                        auditnew = {title: "Noticia Creada",user: trazreport.auditnews[i].attributes.user.attributes.username , date: trazreport.auditnews[i].attributes.createdAt, content:"La noticia fue borrada" };
                    }
                }
                if (trazreport.auditnews[i].attributes.action == "delete") {
                   	auditnew = {title: "Noticia Eliminada",user: trazreport.auditnews[i].attributes.user.attributes.username , date: trazreport.auditnews[i].attributes.createdAt, content:"La noticia fue borrada" };
                }
                if (trazreport.auditnews[i].attributes.action == "edit") {
                    auditnew = {title: "Noticia Editada", user: trazreport.auditnews[i].attributes.user.attributes.username, date: trazreport.auditnews[i].attributes.createdAt, content: trazreport.auditnews[i].attributes.New.attributes.body };
             }
                reporttraz.push(auditnew);
            }
            reporttraz.push(user);
            for (var i = 0; i < trazreport.audituser.length; i++) {
            	var audituser = {};
            	if (trazreport.audituser[i].attributes.action == "DeleteUser") {
            		 audituser = {title: "Usuario Eliminado",user: trazreport.audituser[i].attributes.user.attributes.username , date: trazreport.audituser[i].attributes.createdAt, content:"Usuario Eliminado: "+trazreport.audituser[i].attributes.newvalue };	
            	}
            	if (trazreport.audituser[i].attributes.action == "newuser") {
            		 audituser = {title: "Usuario Creado",user: trazreport.audituser[i].attributes.user.attributes.username , date: trazreport.audituser[i].attributes.createdAt, content:"Usuario Creado: "+trazreport.audituser[i].attributes.newvalue };	
            	}
            	if (trazreport.audituser[i].attributes.action == "newpassword") {
            		 audituser = {title: "Nueva Contraseña para usuario",user: trazreport.audituser[i].attributes.user.attributes.username , date: trazreport.audituser[i].attributes.createdAt, content:"Nueva contraseña para: "+trazreport.audituser[i].attributes.newvalue };	
            	}
            	reporttraz.push(audituser);
            }
        }
        reporttraz.sort(function(a,b){
          return new Date(a.date) - new Date(b.date)
        });
        for (var i = 0; i < reporttraz.length; i++) {
            reporttraz[i].date = reporttraz[i].date.toLocaleDateString('es-GB', options);
            if (trazreport.report != undefined) {
                reporttraz[i].id = trazreport.report[0].id;
            }
        }
        var arrayobj = {} 
        arrayobj.reportid = reporttraz[0].reportid;
        arrayobj.models = reporttraz;
        return arrayobj;
   },
   
});
 export default GeneralView; 
